export default __webpack_public_path__ + "static/media/1_13.91d90892.png";